// Image imports
import shaniPhoto from '../../../images/Shani_by_Rom_Eliaz_3.jpg';

export const shaniLoukMemorial = {
  id: 2,
  name: 'Shani Louk',
  category: 'young-lives',
  images: {
    portrait: shaniPhoto
  },
  info: `

![Shani Louk poses for photographer Rom Eliaz](${shaniPhoto})
"You were an angel on earth and now you are an angel in heaven" -Shanink Website

## A Special Soul

Shani was a very special young woman with a huge heart and a zest for life. She had the remarkable ability to turn any bad situation into something good. Whenever one of her friends was in trouble, Shani was always there to help.

## Family and Roots

Family was important to Shani. She loved coming home at weekends to meet up with her brothers and sister. She also cherished visiting her extended family in Israel and Germany. Shani was a person of deep beliefs who valued her Jewish roots and religion.

## Embracing Others

Naturally interested in other cultures and traditions, Shani respected them and held an intrinsic belief in the goodness of people all over the world. Her love for music and dancing brought her friends from all corners of the globe.

## Dreams and Aspirations

If you had asked Shani about her future plans, she likely would have expressed her desire to:

- Continue designing tattoos
- Design clothes
- Work on stage sets for festivals
- Pursue modeling
- Help people in need

## A Life Well-Lived

Even though Shani's life was much too short, she was mature for her age and lived a very full, exciting, and joyful life. We are so grateful for the life she lived and the goodness she brought to so many people.

## Remembering Shani

May the world remember Shani for the joy, love, and light she radiated. 

[Read more about Shani's life and legacy](https://shaniloukink.com/ABOUT/)

*We will always cherish your memory, Shani.* -Shanink Website

`
};